import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/royce/web/speakers/jay/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/royce/web/speakers/jay/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { Flex as Flexless } from "theme-ui";
import parseResponsiveProp from "../lib/parse-responsive-prop";
var flexbasis = ["auto", "8.33333333%", "16.66666667%", "25%", "33.33333333%", "41.66666667%", "50%", "58.33333333%", "66.66666667%", "75%", "83.33333333%", "91.66666667%", "100%"];
var direction = ["row", "column"];
var order = ["0", "1", "2"];
var wrap = ["wrap", "nowrap"];
var justify = ["flex-start", "center", "flex-end", "space-between"];
var align = ["flex-start", "center", "flex-end"];
var layout = ["static", "relative", "absolute", "fixed"];
var visibility = ["none", "flex"];
var bgrepeat = ["no-repeat", "repeat"];
var fill = ["auto", "100%"];
export default function Flex(_ref) {
  var c = _ref.c,
      offset = _ref.offset,
      o = _ref.o,
      d = _ref.d,
      j = _ref.j,
      a = _ref.a,
      f = _ref.f,
      fw = _ref.fw,
      fh = _ref.fh,
      w = _ref.w,
      h = _ref.h,
      mw = _ref.mw,
      mh = _ref.mh,
      l = _ref.l,
      v = _ref.v,
      bg = _ref.bg,
      bgc = _ref.bgc,
      bgi = _ref.bgi,
      bgr = _ref.bgr,
      bgp = _ref.bgp,
      bgs = _ref.bgs,
      z = _ref.z,
      sx = _ref.sx,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["c", "offset", "o", "d", "j", "a", "f", "fw", "fh", "w", "h", "mw", "mh", "l", "v", "bg", "bgc", "bgi", "bgr", "bgp", "bgs", "z", "sx", "children"]);

  c = parseResponsiveProp(c, flexbasis);
  offset = parseResponsiveProp(offset, flexbasis);
  o = parseResponsiveProp(o, order);
  d = parseResponsiveProp(d, direction);
  j = parseResponsiveProp(j, justify);
  a = parseResponsiveProp(a, align);
  l = parseResponsiveProp(l, layout);
  v = parseResponsiveProp(v, visibility);
  f = parseResponsiveProp(f, fill);
  fw = parseResponsiveProp(fw, fill);
  fh = parseResponsiveProp(fh, fill);
  bgr = parseResponsiveProp(bgr, bgrepeat);
  return /*#__PURE__*/React.createElement(Flexless, _extends({
    sx: _objectSpread({
      flexDirection: d,
      flexWrap: d,
      order: o,
      justifyContent: j,
      alignItems: a,
      flexBasis: c,
      marginLeft: offset,
      maxWidth: c || mw,
      width: f || fw || w,
      height: f || fh || h,
      maxHeight: mh,
      display: v,
      position: l,
      background: bg,
      backgroundImage: bgi,
      backgroundColor: bgc,
      backgroundRepeat: bgr,
      backgroundPosition: bgp,
      backgroundSize: bgs,
      zIndex: z
    }, sx)
  }, rest), children);
}